<header class="site-header transparent">
  <div class="container nav-container">
    <div class="logo">
      <a routerLink="/">
        <!-- <img src="assets/images/BoraLogoTransparente.png" width="120" /> -->
      </a>
    </div>

    <button class="nav-toggle" (click)="open = !open">
      <span></span><span></span><span></span>
    </button>

    <!-- Menú Desktop (el tuyo) -->
    <nav class="nav-links" [class.open]="open">
      <a routerLink="/" routerLinkActive="active">Inicio</a>
      <a routerLink="/about" routerLinkActive="active">Sobre nosotros</a>
      <a routerLink="/menu" routerLinkActive="active">Menú</a>
      <a routerLink="/contact" routerLinkActive="active">Contacto</a>
    </nav>

    <!-- Menú Mobile Fullscreen -->
    <nav class="mobile-overlay" [class.open]="open">
      <div class="mobile-logo">
        <img src="assets/images/BoraLogoTransparente.webp" width="140" />
      </div>

      <a routerLink="/" routerLinkActive="active" (click)="open = false"
        >Inicio</a
      >
      <a routerLink="/about" routerLinkActive="active" (click)="open = false"
        >Sobre nosotros</a
      >
      <a routerLink="/menu" routerLinkActive="active" (click)="open = false"
        >Menú</a
      >
      <a routerLink="/contact" routerLinkActive="active" (click)="open = false"
        >Contacto</a
      >
    </nav>
  </div>
</header>
